import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import SelectFild from '../../../../../components/SelectFild/SelectFild';

import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';
import AircarftImage from "../../../../../assets/images/airplane_orig.jpg";
import AircraftIncursions from "../../../../../assets/images/AircraftIncursions.jpg";
import AircraftIncursions2 from "../../../../../assets/images/AircraftIncursions2.jpg";

const AircraftRelated = ({ details, selectedCheckboxes, postUpdateData, aircraftTypes, airlineOperators, airport, aircraftRegistration, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemNews, setSelectedItemNews] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const initialValues = {
        what_occurred_detail_id: '',
        aircraft_cat_id: '',
        aircraftResCode: "",
        aircraftResNumber: "",
        aircraftType: "",
        airlineOperator: "",
        origin: '',
        destination: '',
        flightNumber: "",
        operationalImpact: "",
    };

    useEffect(() => {
        const detailItem = details?.what_occurred?.details?.["1"]?.[0];
        if (detailItem) {
            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};
            const aircraftIncident = detailItem.aircraft_incidents || {};

            let aircraftCatId = '';
            let parsedAircraftJson = [];
            let parsedaircraftIncursions = [];

            if (aircraftIncident.aircraft_json) {
                try {
                    aircraftCatId = aircraftIncident.id;
                    parsedAircraftJson = JSON.parse(aircraftIncident.aircraft_json);
                    setSelectedItems(parsedAircraftJson);

                    parsedaircraftIncursions = JSON.parse(aircraftIncident.aircraft_incursions);
                    setSelectedItemNews(parsedaircraftIncursions);
                } catch (err) {
                    console.error("Invalid aircraft_json format", err);
                }
            }

            setPreImg(detailItem.image_json);

            formik.setValues({
                what_occurred_detail_id: detailItem.id || '',
                aircraft_cat_id: aircraftCatId || '',
                aircraftResCode: parsedData.aircraftResCode || '',
                aircraftResNumber: parsedData.aircraftResNumber || '',
                aircraftType: parsedData.aircraftType || '',
                airlineOperator: parsedData.airlineOperator || '',
                flightNumber: parsedData.flightNumber || '',
                operationalImpact: parsedData.operationalImpact || '',
                origin: parsedData.origin || '',
                destination: parsedData.destination || '',
            });
        }
    }, [details]);


    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const selectedCatList = JSON.stringify(selectedCheckboxes);
            let param = {
                "aircraftResCode": values.aircraftResCode,
                "aircraftResNumber": values.aircraftResNumber,
                "aircraftType": values.aircraftType,
                "airlineOperator": values.airlineOperator,
                "flightNumber": values.flightNumber,
                "operationalImpact": values.operationalImpact,
                "origin": values.origin,
                "destination": values.destination,
            };
            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["1"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 1;
            const sub_category = selectedCheckboxes["1"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));

            formData.append('aircraft_cat_id', values.aircraft_cat_id);
            formData.append('aircraft_incident_id', values.aircraft_cat_id);

            formData.append('aircraft_json', JSON.stringify(selectedItems));

            formData.append('aircraft_incursions', JSON.stringify(selectedItemNews));

            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });


            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                toast.success(res.data.message);
                postUpdateData();

            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
            console.log('formData', formData);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const checkboxItems = [
        "Horizontal Stabilizer (Control Pitch)",
        "Vertical Stabilizer (Control Yaw)",
        "Rudder (Change Yaw)",
        "Elevator (Change Pitch)",
        "Flaps (Increase Lift and Drag)",
        "Aileron (Change Roll)",
        "Spoiler (Change Lift, Drag and Roll)",
        "Slats (Increase Lift)",
        "Fuselage (Hold Things Together - Carry Payload)",
        "Cockpit (Command and Control)",
        "Turbine Engine (Generate Thrust)",
        "Wing (Generate Lift)",
        "Winglet (Decrease Drag)",
    ];

    const checkboxItemsOne = [
        "Vertical Stabiliser",
        "L3 Door",
        "Left Wing",
        "L2 Door",
        "L1 Door",
        "Cockpit",
        "Nose",
        "Nose Gear",
        "Left Engine",
        "Left Landing Gear",
        "Left Fueselage",
        "Left Horizontal Stabiliser",
    ];

    const checkboxItemsTwo = [
        "R1 Door",
        "R2 Door",
        "Right Wing",
        "R3 Door",
        "Right Horizontal Stabiliser",
        "Hold 5 Door",
        "Rear Hold Door",
        "Right Landing Gear",
        "Right Fueselage",
        "Right Engine",
        "Forward Hold Door",
    ];

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        if (checked) {
            setSelectedItems((prev) => [...prev, value]);
        } else {
            setSelectedItems((prev) => prev.filter((item) => item !== value));
        }
    };

    const handleCheckboxChanges = (event) => {
        const { value, checked } = event.target;

        if (checked) {
            setSelectedItemNews((prev) => [...prev, value]);
        } else {
            setSelectedItemNews((prev) => prev.filter((item) => item !== value));
        }
    };

    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="GroupList fieldset">
                        <div className='toggle-button'>
                            <h2 className="listTitle">Aircraft-Related Incidents</h2>
                            <div className="btnColaps">
                                <FaChevronUp />
                            </div>
                        </div>
                        <div className="formsBox subFilds">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Aircraft Registration</label>
                                        <div className='selectwith_input'>
                                            <div className='selects'>
                                                <SelectFild
                                                    Firstop="Select"
                                                    selectName='aircraftResCode'
                                                    options={aircraftRegistration}
                                                    value={values.aircraftResCode}
                                                    onChange={(selectedOption) => setFieldValue("aircraftResCode", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="aircraftResNumber"
                                                value={values.aircraftResNumber}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        {errors.aircraftResCode && touched.aircraftResCode && (
                                            <p className="errormsg">{errors.aircraftResCode}</p>
                                        )}
                                        {errors.aircraftResNumber && touched.aircraftResNumber && (
                                            <p className="errormsg">{errors.aircraftResNumber}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Aircraft Type</label>
                                        <SelectFild
                                            Firstop="Select Aircraft Type"
                                            selectName='aircraftType'
                                            options={aircraftTypes}
                                            value={values.aircraftType}
                                            onChange={(selectedOption) => setFieldValue("aircraftType", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.aircraftType && touched.aircraftType && (
                                            <p className="errormsg">{errors.aircraftType}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Airline / Operator</label>
                                        <SelectFild
                                            Firstop="Select Airline / Operator"
                                            selectName='airlineOperator'
                                            options={airlineOperators}
                                            value={values.airlineOperator}
                                            onChange={(selectedOption) => setFieldValue("airlineOperator", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.airlineOperator && touched.airlineOperator && (
                                            <p className="errormsg">{errors.airlineOperator}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Origin</label>
                                        <SelectFild
                                            Firstop="Select Origin"
                                            selectName='origin'
                                            options={airport}
                                            value={values.origin}
                                            onChange={(selectedOption) => setFieldValue("origin", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.origin && touched.origin && (
                                            <p className="errormsg">{errors.origin}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Destination</label>
                                        <SelectFild
                                            Firstop="Select Destination"
                                            selectName='destination'
                                            options={airport}
                                            value={values.destination}
                                            onChange={(selectedOption) => setFieldValue("destination", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.destination && touched.destination && (
                                            <p className="errormsg">{errors.destination}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Flight Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="flightNumber"
                                            value={values.flightNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Operational Impact (delay/diversion)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="operationalImpact"
                                            value={values.operationalImpact}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <div id="Aircaraft">
                                <div className="fieldset">
                                    <h1>Aircraft incursions & accidents</h1>
                                    <div className="formsBox">
                                        <div className="aircraftIncursions">
                                            <img src={AircarftImage} alt="Aircraft" />
                                            <div id="AircaraftCheckLists" className="cheklistboxs">
                                                {checkboxItems.map((item, index) => (
                                                    <div className="chekbox" key={index}>
                                                        <input
                                                            type="checkbox"
                                                            value={item}
                                                            onChange={handleCheckboxChange}
                                                            checked={selectedItems.includes(item)}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {selectedItems.length > 0 && (
                                            <div className="fieldset" style={{ display: "block" }}>
                                                <h1>Aircraft incursions & accidents locations</h1>
                                                <div id="AircaraftselectedList" className="selectedList">
                                                    {selectedItems.map((item, idx) => (
                                                        <span key={idx}>{item}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div id="Aircarafts">
                                <div className="fieldset">
                                    <h1>Aircraft incursions & accidents</h1>
                                    <div className="formsBox">
                                        <div className="aircraftIncursions">
                                            <img src={AircraftIncursions} alt="Aircraft" />
                                            <div id="AircaraftCheckLists1" className="cheklistboxs">
                                                {checkboxItemsOne.map((item, index) => (
                                                    <div className="chekbox" key={index}>
                                                        <input
                                                            type="checkbox"
                                                            value={item}
                                                            onChange={handleCheckboxChanges}
                                                            checked={selectedItemNews.includes(item)}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="aircraftIncursions">
                                            <img src={AircraftIncursions2} alt="Aircraft" />
                                            <div id="AircaraftCheckLists2" className="cheklistboxs">
                                                {checkboxItemsTwo.map((item, index) => (
                                                    <div className="chekbox" key={index}>
                                                        <input
                                                            type="checkbox"
                                                            value={item}
                                                            onChange={handleCheckboxChanges}
                                                            checked={selectedItemNews.includes(item)}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {selectedItemNews.length > 0 && (
                                            <div className="fieldset" style={{ display: "block" }}>
                                                <h1>Aircraft incursions & accidents locations</h1>
                                                <div id="AircaraftselectedList" className="selectedList">
                                                    {selectedItemNews.map((item, idx) => (
                                                        <span key={idx}>{item}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <UploadWithSignature onFilesChange={setUploadedFiles} />

                            <div className='previewsimges'>
                                {preImg.map((fileUrl, index) => {
                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div key={index} className='imageboxs'>
                                                <div className='imgs pdfs'>
                                                    <div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                        </div>
                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs'>
                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="button-boxs grid pb-2 pt-2">
                                <button type="submit" className="btn btn-orange">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default AircraftRelated